
const FundSearch = () => {
};

export default FundSearch;